export default __webpack_public_path__ + "static/media/mat-at-vtcc.d8894ca1.jpeg";